'use client'

import { Suspense, lazy, useEffect, useState } from 'react'

import type {
  GeographicDistribution,
  RecipientDashboard,
} from '@/types/usaspending'

import { RecipientGeographyStaticMap } from './RecipientGeographyStaticMap'

const InteractiveRecipientGeographyMap = lazy(() =>
  import('./RecipientGeographyMap').then((m) => ({
    default: m.RecipientGeographyMap,
  })),
)

export interface RecipientGeographyPanelProps {
  data: GeographicDistribution[]
  dashboard?: RecipientDashboard
  height?: number
}

export function RecipientGeographyPanel({
  data,
  dashboard,
  height = 360,
}: RecipientGeographyPanelProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <RecipientGeographyStaticMap data={data} height={height} />
  }

  return (
    <Suspense
      fallback={<RecipientGeographyStaticMap data={data} height={height} />}
    >
      <InteractiveRecipientGeographyMap
        data={data}
        dashboard={dashboard}
        height={height}
      />
    </Suspense>
  )
}
